<template>
    <div>
        <section class="pricedisclosure-page">
            <div class="page-container">
                <div class="content">
                    <span
                        class="eyebrow-page omnes fw-semibold text-orange"
                    ></span>
                    <h1 class="gtitle fw-semibold omnes">
                        Pricing information
                    </h1>
                </div>

                <div class="price-white-box">
                    <p>
                        For pricing disclosures, please visit:
                        <a
                            href=" https://ir.collegiumpharma.com/corporate-governance/compliance"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            https://ir.collegiumpharma.com/corporate-governance/compliance</a
                        >
                    </p>
                </div>
            </div>
        </section>
        <div class="blue-line"></div>
    </div>
</template>

<script>
import headers from '../models/headers';
export default {
    metaInfo: headers.pricePage(),
};
</script>
